/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
export default {
    GetAllGroupsForDropDown,
    GetVCCFactoriesByGroupID,
    GetFinalStatusofSuplierPaymentReport
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFinalStatusofSuplierPaymentReport(model) {
    const response = await CommonPost('/api/FinalStatusofSuplierPaymentReport/GetFinalStatusofSuplierPaymentReport', null, model);
    return response.data;
}

